const POLKADOT = 'polkadot';
const KUSAMA = 'kusama';

export { KUSAMA, POLKADOT };
